import React, { useEffect } from 'react'
import styled from 'styled-components'
import NotFound from '../../img/TitanTV_404.png';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { selectModalOpen, setModalOpen } from '../Modal/modalSlice';
import { handleGA4PageHit } from './GA4Functions';
import { useLocation } from 'react-router-dom';

const PageNotFound = () => {
	const modalOpen = useAppSelector(selectModalOpen);
	const dispatch = useAppDispatch()
	const path = useLocation().pathname;
	useEffect(() => {
		document.title = "Page Not Found | TitanTV";
		document.querySelector('meta[name="description"]')?.setAttribute('content', "Indicates the URL of the desired page cannot be located in TitanTV.com.");
		document.querySelector('meta[name="robots"]')?.setAttribute('content', "noindex");
		window.scrollTo(0, 0);
		handleGA4PageHit({ page: path, title: '404 error page' })
		if (modalOpen) {
			dispatch(setModalOpen());
		}
	})

	return (
		<Img404 src={NotFound} />
	)
}

const Img404 = styled.img`
	width: auto;
	height: 75%;
`

export default PageNotFound